import { type To } from 'react-router-dom';

export function withPreservedSearchHash(
  pathname: string,
  location: Pick<{ search: string; hash: string }, 'search' | 'hash'>
): To {
  return {
    pathname,
    search: location.search,
    hash: location.hash,
  };
}
